<template>
  <div class="Features">
    <div class="FeaturesWrapper">
      <div class="FeaturesTitle">
        <h1>Features</h1>
      </div>
      <div class="FeaturesContent">
        <div class="FeaturesBox">
          <img
            class="FeaturesBoxIcon"
            src="../assets/img/features_icon_1.svg"
            alt="feature icon"
          />
          <h3 class="FeaturesBoxTitle">Access all answers</h3>
          <div class="FeaturesBoxText">
            <p>
              We provide you with the most efficient way to prepare for a
              technical interview, since all the information you need is in one
              place.
            </p>
          </div>
        </div>
        <div class="FeaturesBox">
          <img
            class="FeaturesBoxIcon"
            src="../assets/img/features_icon_2.svg"
            alt="feature icon"
          />
          <h3 class="FeaturesBoxTitle">Track progress</h3>
          <div class="FeaturesBoxText">
            <p>
              A smart interface helps you track your progress and focus on the
              topics you need. You can search through questions or sort them by
              difficulty or type.
            </p>
          </div>
        </div>
        <div class="FeaturesBox">
          <img
            class="FeaturesBoxIcon"
            src="../assets/img/features_icon_3.svg"
            alt="feature icon"
          />
          <h3 class="FeaturesBoxTitle">Save time</h3>
          <div class="FeaturesBoxText">
            <p>
              Save tens of hours searching for information on hundreds of
              low-quality sites designed to drive traffic and make money from
              advertising.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Features',
};
</script>

<style lang="scss" scoped>
.Features {
  display: flex;
  margin-bottom: 150px;
  background-size: cover;
  .FeaturesWrapper {
    width: 1440px;
    margin: 0 auto;
    padding: 0;
  }
}
.FeaturesContent {
  display: flex;
  justify-content: space-between;
}
.FeaturesTitle {
  margin-bottom: 80px;
  text-align: center;
  h1 {
    font-weight: 700;
    font-size: 48px;
    color: $color-black;
  }
}
.FeaturesBox {
  width: 380px;
  height: 460px;
  padding: 80px 40px;
  border-radius: 20px;
  box-sizing: border-box;
  &:nth-child(1) {
    background: url('../assets/img/features_bg_1.svg') top center;
  }
  &:nth-child(2) {
    background: url('../assets/img/features_bg_2.svg') top center;
  }
  &:nth-child(3) {
    background: url('../assets/img/features_bg_3.svg') top center;
  }
  .FeaturesBoxIcon {
    width: 80px;
    margin-bottom: 70px;
  }
  .FeaturesBoxTitle {
    font-weight: 700;
    font-size: 24px;
    margin-bottom: 20px;
    color: $color-white;
  }
  .FeaturesBoxText {
    margin-bottom: 30px;
    font-weight: 400;
    font-size: 16px;
    line-height: 1.5;
    color: $color-white;
    p {
      margin-bottom: 10px;
    }
  }
}

@media screen and (max-width: 1200px) {
  .Features {
    .FeaturesWrapper {
      max-width: 1440px;
      width: 100%;
    }
  }
  .FeaturesTitle {
    h1 {
      font-size: 35px;
    }
  }
  .FeaturesBox {
    width: 320px;
    height: 420px;
    padding: 50px 20px;
    border-radius: 20px;
    box-sizing: border-box;
    .FeaturesBoxIcon {
      width: 70px;
      margin-bottom: 30px;
    }
    .FeaturesBoxTitle {
      font-size: 21px;
    }
    .FeaturesBoxText {
      font-size: 15px;
    }
  }
}

@media screen and (max-width: 1100px) {
  .FeaturesContent {
    .FeaturesBox {
      width: 250px;
      height: 350px;
      padding: 50px 20px;
      .FeaturesBoxIcon {
        width: 40px;
        margin-bottom: 20px;
      }
    }
  }
}

@media screen and (max-width: 650px) {
  .Features {
    .FeaturesTitle {
      h1 {
        font-size: 30px;
      }
    }
    .FeaturesWrapper {
      padding: 0 22px;
    }
    .FeaturesContent {
      flex-direction: column;
    }
    .FeaturesBox {
      width: 100%;
      height: 370px;
      padding: 40px 40px;
      margin-bottom: 50px;
      .FeaturesBoxIcon {
        width: 70px;
        margin-bottom: 30px;
      }
    }
  }
}
</style>
